module.exports = { 

  chatbannertxt: "Start your consultation here and the doctor will call you back",
  writemsghere: "Write Message here",
  incomingcall: "Incoming Video call",
  decline: "Decline",
  accept: "Accept",
  turn_on_camera: 'Turn On Camera',
  add_more_report: "Add more report",
  optional: " (Optional)",
  uploadreport: "Add report",
  upload: "Upload",
  oops:"OOOPS",
  looks_like_the_page:"Looks like the page you’re looking for doesn’t exist. Sorry about that",
  query: "For any further queries",
  plzcntct: "Please contact us on",
  am: "am",
  pm: "pm",
  waiting_note: "Dear Member, kindly wait here, the doctor will call you soon",
  curr_speaking: "Currently Speaking",
  new: "New",
  };


// WEBPACK FOOTER //
// ./src/locales/en.js